<script setup lang="ts">
import Card from 'primevue/card';

import CalculationSegmentsTable from '../components/CalculationSegmentsTable.vue';
import SegmentsSummary from '../components/SegmentsSummary.vue';
import CalculationWidget from '../components/CalculationWidget.vue';
import DownloadAgreement from '../components/DownloadAgreement.vue';
import DownloadOffer from '../components/DownloadOffer.vue';
import DownloadFinancingOffer from '../components/DownloadFinancingOffer.vue';
import DownloadCalculationSummaryCsv from '../components/DownloadCalculationSummaryCsv.vue';
import CalculationOutdatedStatus from '../components/CalculationOutdatedStatus.vue';
import CalculationNameInput from '../components/CalculationNameInput.vue';
import CalculationItemsVisibilityButton from '../components/CalculationItemsVisibilityButton.vue';

import { useCurrentCalculation } from '../composables/useCurrentCalculation';
import { useCurrentEstimatedSegments } from '../composables/useCurrentEstimatedSegments';

const { currentCalculation } = useCurrentCalculation();
const { hasFinancingSegments } = useCurrentEstimatedSegments();
</script>

<template>
  <Card class="h-max flex-1 basis-[354px] border border-gray-200 !shadow-none">
    <template #content>
      <section v-auto-animate class="">
        <div v-auto-animate class="space-y-9">
          <CalculationOutdatedStatus v-if="currentCalculation?.outdated" />

          <header class="flex flex-wrap items-end gap-4">
            <CalculationNameInput
              v-if="currentCalculation"
              class="flex-1"
              :calculation="currentCalculation"
            />

            <CalculationItemsVisibilityButton />
            <DownloadCalculationSummaryCsv />
            <DownloadAgreement />
            <DownloadOffer />
            <DownloadFinancingOffer v-if="hasFinancingSegments" />
          </header>

          <CalculationWidget />

          <CalculationSegmentsTable />

          <SegmentsSummary />
        </div>
      </section>
    </template>
  </Card>
</template>
